import { observer } from 'mobx-react-lite'
import { EmptyState, type IRow, Table, variantActionsProps } from 'shared/ui'
import { type IClickToText } from 'entities/ClickToText'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClickToTextRoutes } from 'pages/clickToText'
import { useClickToTextListContext } from 'pages/clickToText/pages/all/context'
import { columns } from './columns'
import { getClickToTextActions } from './getClickToTextActions'
import styles from './styles.module.scss'

export const ClickToTextTable = observer(() => {
  const {
    limit,
    page,
    isLoading,
    total,
    clickToText,
    tableStore,
    onPaginationModelChange,
    isNoSearchResults,
    onDelete,
  } = useClickToTextListContext()
  const entities = useEntitiesContext()

  const getRows = () => {
    return clickToText.map((item) => {
      item.setActionsProps({
        ...variantActionsProps.table,
        actions: getClickToTextActions({
          clickToText: item,
          onSuccessDelete: () => onDelete(item.id),
          entities,
        }),
      })

      return item
    })
  }

  const getRowLink = (row: IRow<IClickToText>) => {
    return `/${ClickToTextRoutes.root}/${ClickToTextRoutes.view}/${row.id}`
  }

  if (isNoSearchResults) {
    return <EmptyState text='No results found' />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'ClickToTextTable'}
        store={tableStore}
        columns={columns}
        pinnedColumnNames={['name']}
        rows={getRows()}
        getRowLink={getRowLink}
        rowsCount={total}
        isLoading={isLoading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        sortBy={tableStore.sortBy}
        startPaginationSize={10}
      />
    </div>
  )
})
